module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c6285665b5164fa3387b494bf5fa4fef.png";